// @flow
import { fork } from 'redux-saga/effects';
// eslint-disable-next-line import/no-named-as-default
import getProfileInfo from './getProfileInfo';
// eslint-disable-next-line import/no-named-as-default
import getRefSettings from './getRefSettings';
// eslint-disable-next-line import/no-named-as-default
import getRefPayments from './getRefPayments';
// eslint-disable-next-line import/no-named-as-default
import getRefUsers from './getRefUsers';
// eslint-disable-next-line import/no-named-as-default
import postWithdraw from './postWithdraw';
// eslint-disable-next-line import/no-named-as-default
import updateRefCode from './updateRefCode';

export default function* profileSaga() {
  yield fork(getProfileInfo);
  yield fork(getRefSettings);
  yield fork(getRefPayments);
  yield fork(getRefUsers);
  yield fork(postWithdraw);
  yield fork(updateRefCode);
}
